import React from 'react';

import CheckCircle from '../Icons/CheckCircle';
import Error from '../Icons/Error';
import InfoOutlined from '../Icons/InfoOutlined';
import ReportProblem from '../Icons/ReportProblem';

export function getAlertIcon(type: 'success' | 'information' | 'warning' | 'error') {
    if (type === 'information') {
        return <InfoOutlined color="var(--blue)" />;
    }
    if (type === 'warning') {
        return <ReportProblem color="var(--orange)" />;
    }
    if (type === 'error') {
        return <Error color="var(--red)" />;
    }

    return <CheckCircle color="var(--lime)" />;
}
